/**
 * Legacy CartCouponsService entry point — kept ONLY for backwards compatibility.
 *
 * Real implementation: apps/b2b-frontend/app/core/cart/coupons/cart-coupons.service.ts
 * Registered via downgradeInjectable in:
 *   apps/b2b-frontend/app/upgrade/ng-downgraded-components.ts
 * as 'CartCouponsService'.
 */
import angular from 'angular';

// Re-export so existing imports keep working.
export { CartCouponsService, COUPON_CODE_STATUS } from '@ng/core/cart/coupons/cart-coupons.service';
export type { CouponCodeStatus, CartCouponsParent } from '@ng/core/cart/coupons/cart-coupons.service';

/**
 * Empty AngularJS module — preserved so `acme.common.service.cart.coupons`
 * keeps resolving. The actual factory is registered in ng-downgraded-components.ts.
 */

export const CartCouponsServiceModule = angular.module('acme.common.service.cart.coupons', []).name;
